import { render, staticRenderFns } from "./NoteEditMobile.vue?vue&type=template&id=616b520c&scoped=true&"
import script from "./NoteEditMobile.vue?vue&type=script&lang=js&"
export * from "./NoteEditMobile.vue?vue&type=script&lang=js&"
import style0 from "./NoteEditMobile.vue?vue&type=style&index=0&id=616b520c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616b520c",
  null
  
)

component.options.__file = "NoteEditMobile.vue"
export default component.exports